import { Camera } from "lucide-react";
import { GALLERY } from "../data/site";
import { Reveal } from "./Reveal";

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="bg-[#0c1220] py-20 sm:py-28">
    <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
      <Reveal>
        <h2 className="max-w-4xl text-4xl font-black uppercase tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
          CUTS THAT SPEAK FOR THEMSELVES
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#9aa5b5] md:text-lg">
          From clean fades and classic cuts to custom designs and beard work —
          see what Phade Barbers can do.
        </p>
      </Reveal>

      <div data-testid="gallery-grid" className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {GALLERY.map((item, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08}>
            {item.placeholder ? (
              <div
                data-testid={`gallery-placeholder-${i}`}
                className="flex aspect-[4/5] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-white/15 bg-white/[0.03]"
              >
                <Camera className="h-7 w-7 text-white/25" strokeWidth={1.5} />
                <span className="text-[11px] font-bold tracking-[0.2em] text-white/35">
                  PHOTO COMING SOON
                </span>
              </div>
            ) : (
              <div className="group aspect-[4/5] overflow-hidden rounded-lg">
                <img
                  data-testid={`gallery-image-${i}`}
                  src={item.src}
                  alt={item.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
              </div>
            )}
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
